import Image from "next/image";
import Link from "next/link";

import bgImage from "../../public/images/bg/bg-image-10.jpg";

const EpisodeBreadCrumb = ({ blogType, matchedBlog, categoryPath }) => {
  // const pathToSeason = "shorts/s" + matchedBlog.season
  return (
    <>
      <div className="breadcrumb-image-container breadcrumb-style-max-width">
        <div className="breadcrumb-image-wrapper">
          <Image src={bgImage} alt="Education Images" />
        </div>
        <div className="breadcrumb-content-top text-center">
          <ul className="meta-list justify-content-center mb--10">
            <li className="list-item">
              <div className="author-thumbnail">
                {matchedBlog && (
                  <Image
                  src={matchedBlog.author[0].img}
                  width={494}
                    height={494}
                    alt="blog-image"
                  />
                )}
              </div>
              {matchedBlog && (
                <div className="author-info">
                  <Link href="#">
                    <strong>{matchedBlog.name}</strong>
                  </Link>{" "}
                  in{" "}
                  <Link href={categoryPath}>
                    <strong>Shorts/Season {matchedBlog.season}</strong>
                  </Link>
                </div>
              )}
            </li>
            {matchedBlog && (
              <li className="list-item">
                <i className="feather-clock"></i>
                <span>{matchedBlog.date.published}</span>
              </li>
            )}
          </ul>
          {matchedBlog && <h1 className="title">{matchedBlog.title}</h1>}
          {/* {matchedBlog && <p>{matchedBlog.desc}</p>} */}
          <h5>Season {matchedBlog.season} - Episode {matchedBlog.episode}</h5>
        </div>
      </div>
    </>
  );
};

export default EpisodeBreadCrumb;
